import type { Template } from "@/types";

export const PO_07_H5_V2: Template[] = [
    {
        id: "po-07-h5v2-01",
        name: "PO 01 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_01.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 43, y: 156, width: 240, height: 174, rotation: 0, imageRotation: 0 },
            { id: "2", x: 43, y: 338, width: 240, height: 174, rotation: 0, imageRotation: 0 },
            { id: "3", x: 43, y: 520, width: 240, height: 174, rotation: 0, imageRotation: 0 },
            { id: "4", x: 291, y: 156, width: 263, height: 538, rotation: 0, imageRotation: 0 },
            { id: "5", x: 654, y: 239, width: 229, height: 183, rotation: 0, imageRotation: 0 },
            { id: "6", x: 654, y: 430, width: 229, height: 182, rotation: 0, imageRotation: 0 },
            { id: "7", x: 891, y: 239, width: 229, height: 373, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-07-h5v2-02",
        name: "PO 02 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_02.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 67, y: 171, width: 461, height: 329, rotation: 0, imageRotation: 0 },
            { id: "2", x: 67, y: 508, width: 106, height: 172, rotation: 0, imageRotation: 0 },
            { id: "3", x: 180, y: 508, width: 237, height: 172, rotation: 0, imageRotation: 0 },
            { id: "4", x: 424, y: 508, width: 105, height: 172, rotation: 0, imageRotation: 0 },
            { id: "5", x: 662, y: 171, width: 461, height: 336, rotation: 0, imageRotation: 0 },
            { id: "6", x: 662, y: 515, width: 227, height: 164, rotation: 0, imageRotation: 0 },
            { id: "7", x: 896, y: 515, width: 227, height: 164, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-03",
        name: "PO 03 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_03.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 40, y: 171, width: 227, height: 165, rotation: 0, imageRotation: 0 },
            { id: "2", x: 40, y: 344, width: 227, height: 164, rotation: 0, imageRotation: 0 },
            { id: "3", x: 40, y: 516, width: 227, height: 164, rotation: 0, imageRotation: 0 },
            { id: "4", x: 275, y: 171, width: 287, height: 509, rotation: 0, imageRotation: 0 },
            { id: "5", x: 654, y: 171, width: 473, height: 259, rotation: 0, imageRotation: 0 },
            { id: "6", x: 654, y: 438, width: 312, height: 240, rotation: 0, imageRotation: 0 },
            { id: "7", x: 974, y: 438, width: 153, height: 240, rotation: 0, imageRotation: 0 }          
        ],
    },

    {
        id: "po-07-h5v2-04",
        name: "PO 04 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_04.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 0, y: 244, width: 534, height: 406, rotation: 0, imageRotation: 0 },
            { id: "2", x: 541, y: 244, width: 137, height: 199, rotation: 0, imageRotation: 0 },
            { id: "3", x: 973, y: 244, width: 279, height: 199, rotation: 0, imageRotation: 0 },
            { id: "4", x: 685, y: 244, width: 281, height: 199, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1116, y: 451, width: 136, height: 199, rotation: 0, imageRotation: 0 },
            { id: "6", x: 541, y: 451, width: 281, height: 199, rotation: 0, imageRotation: 0 },
            { id: "7", x: 829, y: 451, width: 280, height: 199, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-05",
        name: "PO 05 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_05.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 45, y: 234, width: 310, height: 226, rotation: 0, imageRotation: 0 },
            { id: "2", x: 363, y: 234, width: 310, height: 226, rotation: 0, imageRotation: 0 },
            { id: "3", x: 45, y: 468, width: 204, height: 148, rotation: 0, imageRotation: 0 },
            { id: "4", x: 257, y: 468, width: 204, height: 148, rotation: 0, imageRotation: 0 },
            { id: "5", x: 469, y: 468, width: 204, height: 148, rotation: 0, imageRotation: 0 },
            { id: "6", x: 681, y: 234, width: 228, height: 382, rotation: 0, imageRotation: 0 },
            { id: "7", x: 917, y: 234, width: 228, height: 382, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-06",
        name: "PO 06 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_06.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 48, y: 125, width: 544, height: 396, rotation: 0, imageRotation: 0 },    
            { id: "2", x: 48, y: 529, width: 268, height: 194, rotation: 0, imageRotation: 0 },
            { id: "3", x: 324, y: 529, width: 268, height: 194, rotation: 0, imageRotation: 0 },
            { id: "4", x: 600, y: 125, width: 267, height: 396, rotation: 0, imageRotation: 0 },         
            { id: "5", x: 600, y: 529, width: 267, height: 194, rotation: 0, imageRotation: 0 },
            { id: "6", x: 875, y: 125, width: 267, height: 396, rotation: 0, imageRotation: 0 },
            { id: "7", x: 875, y: 529, width: 267, height: 194, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-07",
        name: "PO 07 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_07.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 176, width: 208, height: 161, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 345, width: 208, height: 161, rotation: 0, imageRotation: 0 },
            { id: "3", x: 0, y: 514, width: 208, height: 161, rotation: 0, imageRotation: 0 },
            { id: "4", x: 216, y: 176, width: 334, height: 499, rotation: 0, imageRotation: 0 },
            { id: "5", x: 558, y: 176, width: 333, height: 499, rotation: 0, imageRotation: 0 },
            { id: "6", x: 899, y: 176, width: 291, height: 246, rotation: 0, imageRotation: 0 },
            { id: "7", x: 899, y: 430, width: 291, height: 245, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-08",
        name: "PO 08 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_08.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 176, width: 208, height: 161, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 345, width: 208, height: 161, rotation: 0, imageRotation: 0 },
            { id: "3", x: 0, y: 514, width: 208, height: 161, rotation: 0, imageRotation: 0 },
            { id: "4", x: 216, y: 176, width: 334, height: 499, rotation: 0, imageRotation: 0 },
            { id: "5", x: 558, y: 176, width: 291, height: 246, rotation: 0, imageRotation: 0 },
            { id: "6", x: 558, y: 430, width: 291, height: 245, rotation: 0, imageRotation: 0 },
            { id: "7", x: 857, y: 176, width: 333, height: 499, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-09",
        name: "PO 09 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_09.png",
        size: [1190, 850],
        style: {},
        slots: [        
            { id: "1", x: 48, y: 153, width: 173, height: 130, rotation: 0, imageRotation: 0 },
            { id: "2", x: 48, y: 291, width: 173, height: 130, rotation: 0, imageRotation: 0 },
            { id: "3", x: 48, y: 429, width: 173, height: 130, rotation: 0, imageRotation: 0 },
            { id: "4", x: 48, y: 567, width: 173, height: 130, rotation: 0, imageRotation: 0 },
            { id: "5", x: 229, y: 153, width: 733, height: 544, rotation: 0, imageRotation: 0 },
            { id: "6", x: 970, y: 153, width: 171, height: 268, rotation: 0, imageRotation: 0 },
            { id: "7", x: 970, y: 429, width: 171, height: 268, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-10",
        name: "PO 10 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_10.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 48, y: 153, width: 734, height: 544, rotation: 0, imageRotation: 0 },
            { id: "2", x: 790, y: 153, width: 173, height: 130, rotation: 0, imageRotation: 0 },
            { id: "3", x: 790, y: 291, width: 173, height: 130, rotation: 0, imageRotation: 0 },
            { id: "4", x: 790, y: 429, width: 173, height: 130, rotation: 0, imageRotation: 0 },
            { id: "5", x: 790, y: 567, width: 173, height: 130, rotation: 0, imageRotation: 0 },
            { id: "6", x: 971, y: 153, width: 171, height: 268, rotation: 0, imageRotation: 0 },
            { id: "7", x: 971, y: 429, width: 171, height: 268, rotation: 0, imageRotation: 0 }
        ],
    }
];